import { useEffect, useState } from 'react';
import api, { ApiResponse } from '../../services/api';
import { useAuthStore, type BirthdayToday } from '../../stores/auth.store';
import BirthdayScreen, { type BirthdayPerson } from './BirthdayScreen';

// Keyed on the server's date (not the browser's) under one overwritten key: a client in another
// timezone can't disagree about "today", and keys never accumulate.
const SEEN_KEY = 'mx_bday_seen';
const seenOn = (today: string) => { try { return localStorage.getItem(SEEN_KEY) === today; } catch { return false; } };
const markSeen = (today: string) => { try { localStorage.setItem(SEEN_KEY, today); } catch { /* ignore */ } };

type MeBirthday = { today?: string; birthdays_today?: BirthdayToday[] };
const nameOf = (b: BirthdayToday) => [b.first_name, b.last_name].filter(Boolean).join(' ') || 'A teammate';

export default function BirthdayManager() {
  const user = useAuthStore((s) => s.user);
  const [show, setShow] = useState<{ people: BirthdayPerson[]; today: string } | null>(null);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    api.get<ApiResponse<MeBirthday>>('/auth/me')
      .then((res) => {
        if (cancelled) return;
        const { today, birthdays_today } = res.data.data ?? {};
        if (!today || seenOn(today)) return;
        const people = (birthdays_today ?? []).map((t) => ({ name: nameOf(t), age: t.age }));
        if (people.length) setShow({ people, today });
      })
      .catch(() => { /* ignore */ });
    return () => { cancelled = true; };
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!show) return null;
  return <BirthdayScreen people={show.people} onClose={() => { markSeen(show.today); setShow(null); }} />;
}
